import { useState, useEffect, useRef } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db, auth } from '../firebase.init';

export const useUserRole = () => {
    const [userData, setUserData] = useState({
        role: '',
        name: '',
        uid: '',
        ready: false,
        user: null
    });

    const previousRoleRef = useRef('');

    useEffect(() => {
        const unsubscribeAuth = auth.onAuthStateChanged((user) => {
            if (!user) {
                setUserData({
                    role: 'guest',
                    name: 'Guest',
                    uid: '',
                    ready: true,
                    user: null
                });
                return;
            }

            const userDocRef = doc(db, 'users', user.uid);

            const unsubscribeSnapshot = onSnapshot(userDocRef, (snap) => {
                if (snap.exists()) {
                    const data = snap.data();
                    const newRole = data.user_role || '';

                    if (previousRoleRef.current && previousRoleRef.current !== newRole) {
                        window.location.reload();
                        return;
                    }

                    previousRoleRef.current = newRole;

                    setUserData({
                        role: newRole,
                        name: data.name || user.displayName || 'User',
                        uid: data.uid || user.uid,
                        ready: true,
                        user: user
                    });
                } else {
                    setUserData({
                        role: 'client',
                        name: user.displayName || user.email || 'User',
                        uid: user.uid,
                        ready: true,
                        user: user
                    });
                }
            }, (error) => {
                // console.error('User document listener error:', error);
                setUserData({
                    role: 'client',
                    name: user.displayName || user.email || 'User',
                    uid: user.uid,
                    ready: true,
                    user: user
                });
            });

            return () => unsubscribeSnapshot();
        });

        return () => unsubscribeAuth();
    }, []);

    return userData;
};